import FormatItem from '@/assets/formats/format-item'

import MyprofileEdit from '@/components/formats/MyprofileEdit'
import MyprofilePreview from '@/components/formats/MyprofilePreview'
import MyprofileCards from '@/assets/formats/myprofile-cards'

import RirekishoSample from '@/assets/formats/sample/rirekisho-sample'
import RirekishoSingleSample from '@/assets/formats/sample/rirekisho-single-sample'
import RirekishoDesign001Sample from '@/assets/formats/sample/rirekisho-design001-sample'

import RirekishoCards from '@/assets/formats/rirekisho-cards'
import RirekishoJISCards from '@/assets/formats/rirekisho-jis-cards'
import RirekishoAiCareerCards from '@/assets/formats/rirekisho-ai-career-cards'
import NewRirekishoCards from '@/assets/formats/new-rirekisho-cards'
import RirekishoNophotoCards from '@/assets/formats/rirekisho-nophoto-cards'
import RirekishoArbeitDebutCards from '@/assets/formats/rirekisho-arbeit-debut-cards'
import DesignRirekisho001Cards from '@/assets/formats/design-rirekisho001-cards'
import DesignRirekisho001Edit from '@/components/formats/DesignRirekisho001Edit'
import DesignRirekisho001Preview from '@/components/formats/DesignRirekisho001Preview'

import RirekishoEdit from '@/components/formats/RirekishoEdit'
import AiRirekishoEdit from '@/components/formats/AiRirekishoEdit'
import NewRirekishoEdit from '@/components/formats/NewRirekishoEdit'
import RirekishoPreview from '@/components/formats/RirekishoPreview'
import AiRirekishoPreview from '@/components/formats/AiRirekishoPreview'

import NewRirekishoPreview from '@/components/formats/NewRirekishoPreview'
import RirekishoShortPreview from '@/components/formats/RirekishoShortPreview'
import RirekishoSinglePreview from '@/components/formats/RirekishoSinglePreview'
import NewRirekishoSinglePreview from '@/components/formats/NewRirekishoSinglePreview'
import RirekishoDoubleNophotoPreview from '@/components/formats/RirekishoDoubleNophotoPreview'
import RirekishoSingleNophotoPreview from '@/components/formats/RirekishoSingleNophotoPreview'

import ShokurekishoCareerEdit from '@/components/formats/ShokurekishoCareerEdit'
import ShokurekishoCareerPreview from '@/components/formats/ShokurekishoCareerPreview'
import ShokurekiCareerCards from '@/assets/formats/shokureki-career-cards'

import ShokurekishoEdit from '@/components/formats/ShokurekishoEdit'
import ShokurekishoPreview from '@/components/formats/ShokurekishoPreview'
// import ShokurekishoPreview from '@/components/formats/ShokurekishoPreviewSample'
import ShokurekishoSample from '@/assets/formats/sample/shokurekisho-sample'
import ShokurekiCards from '@/assets/formats/shokureki-cards'

import EnglishResumeEdit from '@/components/formats/EnglishResumeEdit'
import EnglishResumePreview from '@/components/formats/EnglishResumePreview'
import EnglishResumeSample from '@/assets/formats/sample/english-resume-sample'
import EnglishResumeCards from '@/assets/formats/english-resume-cards'

import ShokurekishoWithImageEdit from '@/components/formats/ShokurekishoWithImageEdit'
import ShokurekishoWithImagePreview from '@/components/formats/ShokurekishoWithImagePreview'
import ShokurekiWithImageCards from '@/assets/formats/shokureki-with-image-cards'

import LetterEdit from '@/components/formats/LetterEdit'
import LetterSample from '@/assets/formats/sample/letter-sample'
import LetterPreview from '@/components/formats/LetterPreview'
import LetterCards from '@/assets/formats/letter-cards'

const jobChangeExampleSentences = {
  // 志望動機
  reason: [
    {
      title: 'スキルアップのために転職したい',
      description:
        '前職ではX年間にわたってXX業務に携わってきました。貴社のXXについては以前から興味を感じており、XXな部分に大変魅力を感じます。今までの経験を活かしながら、さらにXXなどのスキルを身につけ、貴社におけるXX業務に貢献したいと考え志望しました。'
    },
    {
      title: '事業内容に関心がある',
      description:
        '貴社が取り組まれているXX事業に関心があり、応募いたしました。特にXXな点に非常に魅力的を感じています。これまでの私の経験を最大限活用しつつ、ぜひ貴社の一員としてその成長に関わりたいと考えております。'
    },
    {
      title: '自身の経験を活かしたい',
      description:
        '自分のXXXという経験・スキルを活かして貴社に貢献できると考え、この度応募いたしました。今までの経験を活かしながら新しい業務にもチャレンジし、貴社の事業や組織の成長に貢献しながら自分も成長したいと考えております。'
    },
    {
      title: '企業のビジョンに共感した',
      description:
        '貴社のXXXXという企業ビジョンに共感するものがあり、今回応募いたしました。私自身もXXXXという点を大切にしたいと考えており、そのようなビジョンを大切にしている方々と一緒に働きたいと考えております。'
    },
    {
      title: '裁量の大きさに魅力を感じた',
      description:
        '貴社の個々の裁量が大きい職場環境に対して魅力を感じ、今回応募いたしました。責任感を持ちながら、工夫を重ねて成果を出していく職場環境であるということに、自身が成長できる可能性と魅力を感じます。'
    },
    {
      title: '社員に魅力を感じた',
      description:
        '貴社で働かれている社員の方々をXXXXで拝見し、その働き方に魅力を感じて応募いたしました。その中でもXXXという点が、自身の価値観や仕事感に近いと感じました。XXXXを行うことで、貴社への価値貢献をしたいと考えております。'
    },
    {
      title: '未経験職種へ転職したい',
      description:
        '前職ではXXに従事しておりましたが、よりXXに貢献できるような仕事をしたいと考えておりました。今回、貴社のXX求人を拝見し自分もこのような環境で挑戦してみたいと考え、転職を決意致しました。'
    },
    {
      title: '一度離れた職種に戻りたい',
      description:
        '前職ではXX業務に携わり貴重な経験を得ましたが、もう一度XXに戻りたいという思いが強くなりこの度貴社を志望致しました。今までの実務経験の強みを活かしながら、新しい技術に関しても積極的に勉強していきたいと考えています。'
    }
  ],
  // 資格
  license: [
    { title: '自動車免許(MT車)', description: '普通自動車第一種運転免許取得' },
    {
      title: '自動車免許(AT限定)',
      description: '普通自動車第一種運転免許（AT限定）取得'
    },
    { title: '英検', description: '実用英語技能検定X級合格' },
    { title: 'TOEIC', description: 'TOEIC公開テストXXX点取得' },
    { title: 'TOEFL', description: 'iBTテストスコアX点取得' },
    { title: '日商簿記', description: '日商簿記検定試験X級合格' },
    {
      title: 'ファイナンシャルプランナー',
      description: 'ファイナンシャルプランナーX級合格'
    }
  ],
  // 本人希望欄
  request: [
    {
      title: '連絡可能な時間帯',
      description:
        '連絡可能な時間帯：電話の場合、平日18時以降または土日祝日。現在在職中のため、平日日中のご連絡についてはメールでお送り頂ければ幸いです。'
    },
    {
      title: '帰社時間の希望',
      description:
        '子供の保育園の迎えのため、毎週水曜日は18時に退勤させていただければ幸いです。'
    },
    { title: '希望職種', description: '希望職種：XX職を希望します。' },
    {
      title: '希望年収',
      description: '現在の年収はOOO万円です。希望年収はXXX万円となります。'
    },
    { title: '特に希望がない場合', description: '貴社規定に従います。' }
  ],
  // 本人希望欄
  requestShogai: [
    {
      title: '連絡可能な時間帯',
      description:
        '連絡可能な時間帯：電話の場合、平日18時以降または土日祝日。現在在職中のため、平日日中のご連絡についてはメールでお送り頂ければ幸いです。'
    },
    {
      title: '出社時間の希望',
      description: '車いす通勤で満員電車を避けるため、時差出勤を希望します。'
    },
    {
      title: '帰社時間の希望',
      description:
        '子供の保育園の迎えのため、毎週水曜日は18時に退勤させていただければ幸いです。'
    },
    { title: '希望職種', description: '希望職種：XX職を希望します。' },
    {
      title: '希望年収',
      description: '現在の年収はOOO万円です。希望年収はXXX万円となります。'
    },
    { title: '特に希望がない場合', description: '貴社規定に従います。' }
  ]
}
const licenseCommon = [
  { title: '原付免許', description: '原動機付自転車免許取得' },
  { title: '自動車免許', description: '普通自動車第一種運転免許取得' },
  {
    title: '自動車免許(AT限)',
    description: '普通自動車第一種運転免許(AT限定)取得'
  },
  { title: '英検', description: '実用英語技能検定X級合格' },
  { title: 'TOEIC', description: 'TOEIC公開テストXXX点取得' },
  { title: 'TOEFL', description: 'iBTテストスコアX点取得' },
  { title: '日商簿記', description: '日商簿記検定試験X級合格' },
  {
    title: 'ファイナンシャルプランナー',
    description: 'ファイナンシャルプランナーX級合格'
  }
]

const formatsIndex = [
  new FormatItem({
    id: 'myprofile',
    title: 'マイプロフィール',
    description: 'ヤギフレンズのマイプロフィールを作成・編集できます。',
    thumbnail: '/static/img/formats/sample/myprofile_01.png',
    images: [
      '/static/img/formats/sample/myprofile_01.png',
      '/static/img/formats/sample/myprofile_02.png'
    ],
    newdetail1: 'A4サイズ/２枚',
    newdetail2: '',
    newdetail3: 'ヤギフレンズ専用プロフィール',
    newdetail: 'ヤギフレンズ専用',
    pagenumbs: '2枚',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email',
      'contact',
      'contactTel',
      'contactEmail',
      'photo'
    ],
    hashs: ['マイプロフィール'],
    components: {
      edit: MyprofileEdit,
      preview: MyprofilePreview
    },
    cards: MyprofileCards,
    sampleData: RirekishoSample,
    exampleSentences: jobChangeExampleSentences
  }),
  new FormatItem({
    id: 'rirekisho_ai_career',
    title: '転職用のAI履歴書',
    description:
      '転職活動向けの履歴書テンプレートをスマホ・パソコンで無料作成できます。PDFダウンロード・コンビニ印刷にも対応しています。',
    // description: '令和２年７月からスタートした新様式です。日本工業規格（JIS）の規格に従ったA4サイズ2枚の一般的な履歴書テンプレートです。学歴・職歴の記入欄は比較的広めのつくりになっており、社会人経験が長い人にもおすすめです。',
    thumbnail: '/static/img/formats/rirekisho_job_change_ai.png',
    images: [
      '/static/img/formats/sample/rirekisho_job_change_01.jpg',
      '/static/img/formats/sample/rirekisho_job_change_new_02.jpeg'
    ],
    newdetail1: 'A4サイズ/２枚',
    newdetail2: '令和２年７月からスタートした新様式',
    newdetail3: '社会人経験多めの方におすすめ',
    newdetail: 'JIS規格・AI機能強化',
    pagenumbs: '2枚',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email',
      'contact',
      'contactTel',
      'contactEmail',
      'photo'
    ],
    hashs: ['履歴書', '転職'],
    components: {
      edit: AiRirekishoEdit,
      preview: AiRirekishoPreview
    },
    cards: RirekishoAiCareerCards,
    sampleData: RirekishoSample,
    exampleSentences: jobChangeExampleSentences
  }),
  new FormatItem({
    id: 'rirekisho_ai_new',
    title: '新卒用のAI履歴書',
    description:
      '新卒・就職活動向けの履歴書をスマホ・パソコンで無料作成できます。学歴や志望動機、自己PRを入力し、PDFで保存・印刷できます。',
    // description: '令和２年７月からスタートした新様式です。日本工業規格（JIS）の規格に従ったA4サイズ2枚の一般的な履歴書テンプレートです。学歴・職歴の記入欄は比較的広めのつくりになっており、社会人経験が長い人にもおすすめです。',
    thumbnail: '/static/img/formats/rirekisho_job_change_ai_new.png',
    images: [
      '/static/img/formats/sample/rirekisho_job_change_01.jpg',
      '/static/img/formats/sample/rirekisho_job_change_new_02.jpeg'
    ],
    newdetail1: 'A4サイズ/２枚',
    newdetail2: '令和２年７月からスタートした新様式',
    newdetail3: '社会人経験多めの方におすすめ',
    newdetail: '社会人経験多めの方向け',
    pagenumbs: '2枚',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email',
      'contact',
      'contactTel',
      'contactEmail',
      'photo'
    ],
    hashs: ['履歴書', '転職'],
    components: {
      edit: RirekishoEdit,
      preview: RirekishoPreview
    },
    cards: RirekishoJISCards,
    sampleData: RirekishoSample,
    exampleSentences: jobChangeExampleSentences
  }),
  new FormatItem({
    id: 'rirekisho_design_001',
    title: '新デザイン履歴書(beta)',
    description:
      '転職活動向けの履歴書テンプレートをスマホ・パソコンで無料作成できます。PDFダウンロード・コンビニ印刷にも対応しています。',
    thumbnail: '/static/img/formats/sample/rirekisho_design_001_01.jpg',
    images: ['/static/img/formats/sample/rirekisho_design_001_01.jpg'],
    newdetail1: 'A4サイズ/２枚',
    newdetail2: '令和２年７月からスタートした新様式',
    newdetail3: '社会人経験多めの方におすすめ',
    newdetail: '社会人経験多めの方向け',
    pagenumbs: '2枚',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'tel',
      'email',
      'photo'
    ],
    hashs: ['履歴書', '転職'],
    components: {
      edit: DesignRirekisho001Edit,
      preview: DesignRirekisho001Preview
    },
    cards: DesignRirekisho001Cards,
    sampleData: RirekishoDesign001Sample,
    exampleSentences: jobChangeExampleSentences
  }),
  // new FormatItem({
  //   id: 'rirekisho_esf_challenged',
  //   title: '障がい者向け履歴書',
  //   description: '豊富な例文やサンプル、フォーマットを用意しています。PCやスマホにも対応。',
  //   // description: '就労支援施設をご利用されている障がい者専用の履歴書フォーマットです。日本工業規格（JIS）の規格に従ったA4サイズ2枚の一般的な履歴書テンプレートです。',
  //   thumbnail: '/static/img/formats/rirekisho_job_change.png',
  //   images: [
  //     '/static/img/formats/sample/rirekisho_job_change_01.jpg',
  //     '/static/img/formats/sample/rirekisho_job_change_new_02.jpeg'
  //   ],
  //   newdetail1: 'A4サイズ/２枚',
  //   newdetail2: '',
  //   newdetail3: '障がい者雇用希望の方におすすめ',
  //   newdetail: '障がい者雇用希望の方向け',
  //   pagenumbs: '2枚',
  //   requiredBasicFields: ['name', 'furigana', 'birth', 'sex', 'address', 'addressFurigana', 'tel', 'email', 'contact', 'contactTel', 'contactEmail', 'photo'],
  //   hashs: ['履歴書', '転職'],
  //   components: {
  //     edit: ShogaiRirekishoEdit,
  //     preview: RirekishoShogaiPreview
  //   },
  //   cards: RirekishoShogaiCards,
  //   sampleData: RirekishoSample,
  //   exampleSentences: jobChangeShogaiExampleSentences
  // }),
  new FormatItem({
    id: 'rirekisho_job_change',
    title: '転職用の履歴書（厚生労働省様式ベース）',
    description:
      '転職活動向けの履歴書テンプレートをスマホ・パソコンで無料作成できます。PDFダウンロード・コンビニ印刷にも対応しています。',
    // description: '令和２年７月からスタートした新様式です。日本工業規格（JIS）の規格に従ったA4サイズ2枚の一般的な履歴書テンプレートです。学歴・職歴の記入欄は比較的広めのつくりになっており、社会人経験が長い人にもおすすめです。',
    thumbnail: '/static/img/formats/rirekisho_job_change.png',
    images: [
      '/static/img/formats/sample/rirekisho_job_change_01.jpg',
      '/static/img/formats/sample/rirekisho_job_change_new_02.jpeg'
    ],
    newdetail1: 'A4サイズ/２枚',
    newdetail2: '令和２年７月からスタートした新様式',
    newdetail3: '社会人経験多めの方におすすめ',
    newdetail: '社会人経験多めの方向け',
    pagenumbs: '2枚',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email',
      'contact',
      'contactTel',
      'contactEmail',
      'photo'
    ],
    hashs: ['履歴書', '転職'],
    components: {
      edit: RirekishoEdit,
      preview: RirekishoPreview
    },
    cards: RirekishoJISCards,
    sampleData: RirekishoSample,
    exampleSentences: jobChangeExampleSentences
  }),
  new FormatItem({
    id: 'letter',
    title: '送付状',
    description:
      '豊富な例文やサンプル、フォーマットを用意しています。PCやスマホにも対応。',
    // description: 'A4サイズの送付状テンプレートです。送付状を入れておくことで、丁寧な印象を与えることができます。面接官の印象がガラッと変わるので、1枚入れておくことをオススメします。',
    thumbnail: '/static/img/formats/sample/yagish_letter_img.jpeg',
    images: ['/static/img/formats/sample/yagish_letter_img.jpeg'],
    newdetail1: 'A4サイズ推奨',
    newdetail2: '',
    newdetail3: '全36種類のあいさつ季語を例文から選べます',
    newdetail: '',
    requiredBasicFields: ['name', 'address', 'tel', 'email'],
    hashs: ['送付状'],
    components: {
      edit: LetterEdit,
      preview: LetterPreview
    },
    cards: LetterCards,
    sampleData: LetterSample,
    exampleSentences: {
      intro: [
        {
          type: 'others',
          name: '一般的なあいさつ',
          sentences:
            '拝啓\u3000貴社におかれましてはますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '一般的なあいさつ',
          sentences: '拝啓\u3000貴社ますますご清栄のこととお慶び申し上げます'
        },
        {
          type: 'others',
          name: '1月のあいさつ',
          sentences:
            '拝啓\u3000初春の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '1月のあいさつ',
          sentences:
            '拝啓\u3000新春の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '1月のあいさつ',
          sentences:
            '拝啓\u3000厳冬の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '2月のあいさつ',
          sentences:
            '拝啓\u3000立春の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '2月のあいさつ',
          sentences:
            '拝啓\u3000早春の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '2月のあいさつ',
          sentences:
            '拝啓\u3000残寒の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '3月のあいさつ',
          sentences:
            '拝啓\u3000春分の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '3月のあいさつ',
          sentences:
            '拝啓\u3000春陽の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '3月のあいさつ',
          sentences:
            '拝啓\u3000浅春の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '4月のあいさつ',
          sentences:
            '拝啓\u3000春暖の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '4月のあいさつ',
          sentences:
            '拝啓\u3000陽春の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '4月のあいさつ',
          sentences:
            '拝啓\u3000仲春の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '5月のあいさつ',
          sentences:
            '拝啓\u3000新緑の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '5月のあいさつ',
          sentences:
            '拝啓\u3000薫風の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '5月のあいさつ',
          sentences:
            '拝啓\u3000立夏の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '6月のあいさつ',
          sentences:
            '拝啓\u3000小夏の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '6月のあいさつ',
          sentences:
            '拝啓\u3000入梅の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '6月のあいさつ',
          sentences:
            '拝啓\u3000梅雨の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '7月のあいさつ',
          sentences:
            '拝啓\u3000盛夏の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '7月のあいさつ',
          sentences:
            '拝啓\u3000仲夏の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '7月のあいさつ',
          sentences:
            '拝啓\u3000猛暑の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '8月のあいさつ',
          sentences:
            '拝啓\u3000残暑の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '8月のあいさつ',
          sentences:
            '拝啓\u3000晩夏の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '8月のあいさつ',
          sentences:
            '拝啓\u3000立秋の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '9月のあいさつ',
          sentences:
            '拝啓\u3000初秋の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '9月のあいさつ',
          sentences:
            '拝啓\u3000新秋の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '9月のあいさつ',
          sentences:
            '拝啓\u3000秋冷の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '10月のあいさつ',
          sentences:
            '拝啓\u3000仲秋の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '10月のあいさつ',
          sentences:
            '拝啓\u3000秋涼の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '10月のあいさつ',
          sentences:
            '拝啓\u3000秋晴の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '11月のあいさつ',
          sentences:
            '拝啓\u3000晩秋の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '11月のあいさつ',
          sentences:
            '拝啓\u3000向寒の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '11月のあいさつ',
          sentences:
            '拝啓\u3000菊花の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '12月のあいさつ',
          sentences:
            '拝啓\u3000師走の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '12月のあいさつ',
          sentences:
            '拝啓\u3000初冬の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        },
        {
          type: 'others',
          name: '12月のあいさつ',
          sentences:
            '拝啓\u3000寒冷の候、貴社ますますご繁栄のこととお慶び申し上げます。'
        }
      ],
      entry: [
        {
          type: 'others',
          name: '一般的な応募経緯',
          sentences:
            'この度、貴社の○○職に応募させて頂きたく、下記の応募書類を送付させて頂きます。\nぜひご検討頂き、面接の機会を頂けますと幸いに存じます。何卒宜しくお願い申し上げます。'
        },
        {
          type: 'others',
          name: '詳細に経緯を説明',
          sentences:
            'この度、〇〇に掲載されておりました、〇〇職の求人に応募させていただきます。\n\n私は３年間にわたり海外営業として勤務しており、国内勤務をしながら海外の顧客を担当してまいりました。これまでの経験を活かして貴社の〇〇業務に貢献したいと考え、応募させていただきました。\n\nご検討の上、是非ともご面談の機会をいただけますと幸いです。\n\nご査収のほど、宜しくお願い申し上げます。'
        }
      ],
      resume: [
        { type: 'others', name: '', sentences: 'はじめての転職大学卒業。' },
        { type: 'others', name: '', sentences: '2社の転職を経験大学を卒業。' },
        { type: 'others', name: '', sentences: '複数の転職を経験大学を卒業。' }
      ],
      prMessage: [
        {
          type: 'others',
          name: '',
          sentences: ''
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        },
        {
          type: 'others',
          name: '',
          sentences: ''
        }
      ]
    }
  }),
  new FormatItem({
    id: 'shokumukeirekisho_type_career',
    title: 'キャリア式職務経歴書',
    description:
      '経験した業務や携わったプロジェクトを基準にして職務経歴書を書けます。',
    // description: 'A4サイズの職務経歴書テンプレートです。自分のスキル・経験や、会社ごとに実績など一般的な項目が入力できます。転職活動などでお使いください。※職務経歴書のコンビニ印刷は、最大8ページ(白黒A4両面4枚)までの対応となります。',
    // thumbnail: '/static/img/formats/rirekisho_job_change.png',
    thumbnail: '/static/img/formats/shokurekisho-min.png',
    images: [
      // '/static/img/formats/sample/rirekisho_job_change_01.jpg',
      // '/static/img/formats/sample/rirekisho_job_change_02.jpg'
      '/static/img/formats/sample/shokurekisho.png'
    ],
    newdetail1: 'A4サイズ',
    newdetail2: '',
    newdetail3: 'コンビニ印刷は、最大8ページ(白黒A4両面4枚)まで対応',
    // requiredBasicFields: ['name', 'email'],
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email'
    ],
    hashs: ['キャリア式職務経歴書'],
    components: {
      edit: ShokurekishoCareerEdit,
      preview: ShokurekishoCareerPreview
    },
    // cards: RirekishoCards,
    cards: ShokurekiCareerCards,
    sampleData: ShokurekishoSample,
    // exampleSentences: jobChangeExampleSentences
    exampleSentences: {
      summary: [
        {
          type: 'others',
          name: 'はじめての転職',
          sentences:
            '大学卒業後、株式会社XXに入社。XX事業部・XX職として配属されました。主にXXを担当し、XXに関する業務やXXに携わってきました。'
        },
        {
          type: 'others',
          name: '2社の転職を経験',
          sentences:
            '大学を卒業後、新卒でXX会社に入社しXX職としてXX業界のXXに携わりました。2社目のXX社ではXX職としてXXやXXを担当、XXの経験を積みました。'
        },
        {
          type: 'others',
          name: '複数社の転職を経験',
          sentences:
            '大学を卒業後、XX会社のXX職をX年勤めたのち、XX会社のXX職やXX会社のXX職を経験。20XX年より株式会社XXに入社し、XX職として勤務。主にXXに従事し、XXやXXの業務を担当しています。'
        }
        // {type: 'others', name: 'エンジニア', sentences: '大学を卒業後、ソフトウェア開発会社に入社。一貫して金融業界の業務システム開発に携わる。1社目ではシステムエンジニアとしてプログラム基本設計から開発、テストをｘ年担当後、プロジェクトリーダーとしてプロジェクトの進捗管理を担当。2社目のシステムインテグレーターでは、加えて顧客折衝の経験を積む。'},
        // {type: 'others', name: '営業', sentences: '大学を卒業後、求人情報サイトを運営する株式会社◯◯に入社。営業職として、新規顧客の開拓を中心に取り組んでおりました。直近3年間は毎年目標売上を達成、昨年は120％達成により社内賞も受賞しました。チームリーダーを任されており、3名のチームメンバーの業績管理の経験もあります。'},
        // {type: 'others', name: '事務', sentences: '株式会社〇〇において、営業事務として5年間従事。営業担当8名の営業資料や契約書類の作成に加え、電話対応・来客対応・精算業務などに携わってきました。商品の知識を深めて営業担当とコミュニケーションをとることで、バックオフィスとの連携が円滑に回るようになり売上向上につながったと評価をいただきました。また、業務フローの整備や書類作成の簡略化など日々の業務の効率化にも取り組み、会社に貢献してきました。'},
        // {type: 'others', name: 'その他', sentences: '大学卒業後、株式会社〇〇に入社。XXといった業務に携わってきました。社外との折衝業務が多く、社内・外を問わず円滑なコミュニケーションを心掛けてきました。在職中はxxxxの資格を取得し、現在xxxxのスペシャリストを目指して勉強しております。今後は前職の経験を活かし、短期間で貴社の戦力となれるよう努力いたします。'}
      ],
      prMessage: [
        {
          type: 'others',
          name: 'スキルをアピール',
          sentences:
            '現職にてXXを目的としたXXに関わり、実務経験を積んできました。新しい技術や情報についても積極的に勉強し、チームのメンバーも交えて情報共有しながら実務で活かすように取り組んでいます。'
        },
        {
          type: 'others',
          name: '同業種・業界での経験をアピール',
          sentences:
            '現職では、XXメーカーのXX業務に長年携わっていました。ターゲットであるXXに適したXXなどの施策を実施し、前年対比XXX％の売上を達成しました。今までに学んできたXXの経験を、今回応募した貴社のXXでも活かしたいと考えています。'
        },
        {
          type: 'others',
          name: 'マネジメント経験をアピール',
          sentences:
            '現職にてマネージャーをX年間経験しまし、社員が互いに刺激を与え合いながら成長していく組織作りに注力してきました。結果、社員同士の意識が目標に対して統一され、速やかな数値達成ができました。柔軟な対応力とXXの経験を、今回応募した貴社のXXでも活かしたいと考えています。'
        },
        {
          type: 'others',
          name: '事務能力の高さ・効率性をアピール',
          sentences:
            'ケアレスミスをなくし、常に効率改善の余地がないか考えながら業務に取り組むように心がけています。現職では業務フローの見直しや日々の書類業務の自動化を主導しまし、全体の作業時間をXX％短縮させることに成功しました。特にXX関連業務の書類・ドキュメント作成の経験が豊富なことが強みです。'
        },
        {
          type: 'others',
          name: '意欲・熱意をアピール（実務未経験）',
          sentences:
            'XXがきっかけでXXという仕事に魅力を感じ、XXスクールやXX講座に通い自主的に勉強を続けてきました。今回、実務経験がなくても熱意や意欲次第で採用を検討されていると拝見し、応募をさせていただきました。未経験ではありますが、XXに関する知識やスキルを高める努力をしながら貴社の事業に貢献したいと考えています。'
        }
        // {type: 'others', name: 'エンジニア', sentences: '開発経験が豊富です。現職にて自社運営サイトのアクセス増加を目的とした新規機能開発に携わりました。サーバーサイドを担当し高速化・効率化を実現してきました。実務でのプログラミング経験から得た知識に加え、最近はプライベートでandroidアプリケーションの開発も行いました。新しい技術に関しても積極的に取り組んでいきます。チームマネジメント経験があります。少人数ながらチームリーダーを担当しました。メンバー間のコミュニケーションを重要視して円滑な進捗はもちろん、職務を通して全員がスキルアップしながら開発が行えるようマネジメントを心掛けました。'
        // },
        // {type: 'others', name: '営業', sentences: '前職では、エリアマネージャーを計5年経験しました。売上目標達成のため、店舗ごとに定期的に分析を行いKPIを設定。メンバーにはKPIとして設定したプロセスを完遂することを要望しました。その結果、目標を全て達成。売上目標も当初から20%増と推移し、非常に高い成果を残すことができました。扱う商材は変わりますが、お客様や店舗の状況を調査し戦略を立てた経験や、多数のメンバーのマネジメント経験は、貴社でも活かせるものと思います。'},
        // {type: 'others', name: '事務', sentences: '期限を守った上でミスなく確実にドキュメント作成を行ってきました。ダブルチェックを徹底し責任をもって仕事を仕上げます。また、常に効率改善の余地がないか考えながら日々の業務に取り組みます。前職では業務フローの見直しや日々の書類業務の自動化を主導し、全体の作業時間を大幅に短縮させることに成功しました。事務能力を活かして貴社に貢献したいと考えております。'},
        // {type: 'others', name: 'その他', sentences: '前職にてマネージャーを3年間経験しました。社員が互いに刺激を与え合いながら成長していく組織作りに注力してきました。結果として社員同士の意識が目標に対して統一され、速やかな数値達成ができました。柔軟な対応力と〇〇の経験を活かして、必ず貴社でお役に立てるものと考えております。何事も素直に吸収していけるよう、努力する気持ちを忘れずに頑張ります。'}
      ]
    }
  }),
  new FormatItem({
    id: 'shokumukeirekisho',
    title: '職務経歴書',
    description:
      '転職活動に使える職務経歴書をスマホ・パソコンで無料作成できます。職歴や実績、自己PRを入力し、PDFで保存・印刷できます。',
    // description: 'A4サイズの職務経歴書テンプレートです。自分のスキル・経験や、会社ごとに実績など一般的な項目が入力できます。転職活動などでお使いください。※職務経歴書のコンビニ印刷は、最大8ページ(白黒A4両面4枚)までの対応となります。',
    // thumbnail: '/static/img/formats/rirekisho_job_change.png',
    thumbnail: '/static/img/formats/shokurekisho-min.png',
    images: [
      // '/static/img/formats/sample/rirekisho_job_change_01.jpg',
      // '/static/img/formats/sample/rirekisho_job_change_02.jpg'
      '/static/img/formats/sample/shokurekisho.png'
    ],
    newdetail1: 'A4サイズ',
    newdetail2: '',
    newdetail3: 'コンビニ印刷は、最大8ページ(白黒A4両面4枚)まで対応',
    // requiredBasicFields: ['name', 'email'],
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email'
    ],
    hashs: ['職務経歴書'],
    components: {
      edit: ShokurekishoEdit,
      preview: ShokurekishoPreview
    },
    // cards: RirekishoCards,
    cards: ShokurekiCards,
    sampleData: ShokurekishoSample,
    // exampleSentences: jobChangeExampleSentences
    exampleSentences: {
      summary: [
        {
          type: 'others',
          name: 'はじめての転職',
          sentences:
            '大学卒業後、株式会社XXに入社。XX事業部・XX職として配属されました。主にXXを担当し、XXに関する業務やXXに携わってきました。'
        },
        {
          type: 'others',
          name: '2社の転職を経験',
          sentences:
            '大学を卒業後、新卒でXX会社に入社しXX職としてXX業界のXXに携わりました。2社目のXX社ではXX職としてXXやXXを担当、XXの経験を積みました。'
        },
        {
          type: 'others',
          name: '複数社の転職を経験',
          sentences:
            '大学を卒業後、XX会社のXX職をX年勤めたのち、XX会社のXX職やXX会社のXX職を経験。20XX年より株式会社XXに入社し、XX職として勤務。主にXXに従事し、XXやXXの業務を担当しています。'
        }
        // {type: 'others', name: 'エンジニア', sentences: '大学を卒業後、ソフトウェア開発会社に入社。一貫して金融業界の業務システム開発に携わる。1社目ではシステムエンジニアとしてプログラム基本設計から開発、テストをｘ年担当後、プロジェクトリーダーとしてプロジェクトの進捗管理を担当。2社目のシステムインテグレーターでは、加えて顧客折衝の経験を積む。'},
        // {type: 'others', name: '営業', sentences: '大学を卒業後、求人情報サイトを運営する株式会社◯◯に入社。営業職として、新規顧客の開拓を中心に取り組んでおりました。直近3年間は毎年目標売上を達成、昨年は120％達成により社内賞も受賞しました。チームリーダーを任されており、3名のチームメンバーの業績管理の経験もあります。'},
        // {type: 'others', name: '事務', sentences: '株式会社〇〇において、営業事務として5年間従事。営業担当8名の営業資料や契約書類の作成に加え、電話対応・来客対応・精算業務などに携わってきました。商品の知識を深めて営業担当とコミュニケーションをとることで、バックオフィスとの連携が円滑に回るようになり売上向上につながったと評価をいただきました。また、業務フローの整備や書類作成の簡略化など日々の業務の効率化にも取り組み、会社に貢献してきました。'},
        // {type: 'others', name: 'その他', sentences: '大学卒業後、株式会社〇〇に入社。XXといった業務に携わってきました。社外との折衝業務が多く、社内・外を問わず円滑なコミュニケーションを心掛けてきました。在職中はxxxxの資格を取得し、現在xxxxのスペシャリストを目指して勉強しております。今後は前職の経験を活かし、短期間で貴社の戦力となれるよう努力いたします。'}
      ],
      prMessage: [
        {
          type: 'others',
          name: 'スキルをアピール',
          sentences:
            '現職にてXXを目的としたXXに関わり、実務経験を積んできました。新しい技術や情報についても積極的に勉強し、チームのメンバーも交えて情報共有しながら実務で活かすように取り組んでいます。'
        },
        {
          type: 'others',
          name: '同業種・業界での経験をアピール',
          sentences:
            '現職では、XXメーカーのXX業務に長年携わっていました。ターゲットであるXXに適したXXなどの施策を実施し、前年対比XXX％の売上を達成しました。今までに学んできたXXの経験を、今回応募した貴社のXXでも活かしたいと考えています。'
        },
        {
          type: 'others',
          name: 'マネジメント経験をアピール',
          sentences:
            '現職にてマネージャーをX年間経験しまし、社員が互いに刺激を与え合いながら成長していく組織作りに注力してきました。結果、社員同士の意識が目標に対して統一され、速やかな数値達成ができました。柔軟な対応力とXXの経験を、今回応募した貴社のXXでも活かしたいと考えています。'
        },
        {
          type: 'others',
          name: '事務能力の高さ・効率性をアピール',
          sentences:
            'ケアレスミスをなくし、常に効率改善の余地がないか考えながら業務に取り組むように心がけています。現職では業務フローの見直しや日々の書類業務の自動化を主導しまし、全体の作業時間をXX％短縮させることに成功しました。特にXX関連業務の書類・ドキュメント作成の経験が豊富なことが強みです。'
        },
        {
          type: 'others',
          name: '意欲・熱意をアピール（実務未経験）',
          sentences:
            'XXがきっかけでXXという仕事に魅力を感じ、XXスクールやXX講座に通い自主的に勉強を続けてきました。今回、実務経験がなくても熱意や意欲次第で採用を検討されていると拝見し、応募をさせていただきました。未経験ではありますが、XXに関する知識やスキルを高める努力をしながら貴社の事業に貢献したいと考えています。'
        }
        // {type: 'others', name: 'エンジニア', sentences: '開発経験が豊富です。現職にて自社運営サイトのアクセス増加を目的とした新規機能開発に携わりました。サーバーサイドを担当し高速化・効率化を実現してきました。実務でのプログラミング経験から得た知識に加え、最近はプライベートでandroidアプリケーションの開発も行いました。新しい技術に関しても積極的に取り組んでいきます。チームマネジメント経験があります。少人数ながらチームリーダーを担当しました。メンバー間のコミュニケーションを重要視して円滑な進捗はもちろん、職務を通して全員がスキルアップしながら開発が行えるようマネジメントを心掛けました。'
        // },
        // {type: 'others', name: '営業', sentences: '前職では、エリアマネージャーを計5年経験しました。売上目標達成のため、店舗ごとに定期的に分析を行いKPIを設定。メンバーにはKPIとして設定したプロセスを完遂することを要望しました。その結果、目標を全て達成。売上目標も当初から20%増と推移し、非常に高い成果を残すことができました。扱う商材は変わりますが、お客様や店舗の状況を調査し戦略を立てた経験や、多数のメンバーのマネジメント経験は、貴社でも活かせるものと思います。'},
        // {type: 'others', name: '事務', sentences: '期限を守った上でミスなく確実にドキュメント作成を行ってきました。ダブルチェックを徹底し責任をもって仕事を仕上げます。また、常に効率改善の余地がないか考えながら日々の業務に取り組みます。前職では業務フローの見直しや日々の書類業務の自動化を主導し、全体の作業時間を大幅に短縮させることに成功しました。事務能力を活かして貴社に貢献したいと考えております。'},
        // {type: 'others', name: 'その他', sentences: '前職にてマネージャーを3年間経験しました。社員が互いに刺激を与え合いながら成長していく組織作りに注力してきました。結果として社員同士の意識が目標に対して統一され、速やかな数値達成ができました。柔軟な対応力と〇〇の経験を活かして、必ず貴社でお役に立てるものと考えております。何事も素直に吸収していけるよう、努力する気持ちを忘れずに頑張ります。'}
      ]
    }
  }),
  new FormatItem({
    id: 'shokumukeirekisho_with_image',
    title: '画像で伝える職務経歴書',
    description:
      '職務経歴書に、自分のプロジェクトや成果物を画像付きでアピールすることができます。',
    thumbnail: '/static/img/formats/shokurekisho-min.png',
    images: ['/static/img/formats/sample/shokurekisho.png'],
    newdetail1: 'A4サイズ',
    newdetail2: '',
    newdetail3: 'コンビニ印刷は、最大8ページ(白黒A4両面4枚)まで対応',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email'
    ],
    hashs: ['画像で伝える職務経歴書'],
    components: {
      edit: ShokurekishoWithImageEdit,
      preview: ShokurekishoWithImagePreview
    },
    cards: ShokurekiWithImageCards,
    sampleData: ShokurekishoSample,
    exampleSentences: {
      summary: [
        {
          type: 'others',
          name: 'はじめての転職',
          sentences:
            '大学卒業後、株式会社XXに入社。XX事業部・XX職として配属されました。主にXXを担当し、XXに関する業務やXXに携わってきました。'
        },
        {
          type: 'others',
          name: '2社の転職を経験',
          sentences:
            '大学を卒業後、新卒でXX会社に入社しXX職としてXX業界のXXに携わりました。2社目のXX社ではXX職としてXXやXXを担当、XXの経験を積みました。'
        },
        {
          type: 'others',
          name: '複数社の転職を経験',
          sentences:
            '大学を卒業後、XX会社のXX職をX年勤めたのち、XX会社のXX職やXX会社のXX職を経験。20XX年より株式会社XXに入社し、XX職として勤務。主にXXに従事し、XXやXXの業務を担当しています。'
        }
      ],
      prMessage: [
        {
          type: 'others',
          name: 'スキルをアピール',
          sentences:
            '現職にてXXを目的としたXXに関わり、実務経験を積んできました。新しい技術や情報についても積極的に勉強し、チームのメンバーも交えて情報共有しながら実務で活かすように取り組んでいます。'
        },
        {
          type: 'others',
          name: '同業種・業界での経験をアピール',
          sentences:
            '現職では、XXメーカーのXX業務に長年携わっていました。ターゲットであるXXに適したXXなどの施策を実施し、前年対比XXX％の売上を達成しました。今までに学んできたXXの経験を、今回応募した貴社のXXでも活かしたいと考えています。'
        },
        {
          type: 'others',
          name: 'マネジメント経験をアピール',
          sentences:
            '現職にてマネージャーをX年間経験しまし、社員が互いに刺激を与え合いながら成長していく組織作りに注力してきました。結果、社員同士の意識が目標に対して統一され、速やかな数値達成ができました。柔軟な対応力とXXの経験を、今回応募した貴社のXXでも活かしたいと考えています。'
        },
        {
          type: 'others',
          name: '事務能力の高さ・効率性をアピール',
          sentences:
            'ケアレスミスをなくし、常に効率改善の余地がないか考えながら業務に取り組むように心がけています。現職では業務フローの見直しや日々の書類業務の自動化を主導しまし、全体の作業時間をXX％短縮させることに成功しました。特にXX関連業務の書類・ドキュメント作成の経験が豊富なことが強みです。'
        },
        {
          type: 'others',
          name: '意欲・熱意をアピール（実務未経験）',
          sentences:
            'XXがきっかけでXXという仕事に魅力を感じ、XXスクールやXX講座に通い自主的に勉強を続けてきました。今回、実務経験がなくても熱意や意欲次第で採用を検討されていると拝見し、応募をさせていただきました。未経験ではありますが、XXに関する知識やスキルを高める努力をしながら貴社の事業に貢献したいと考えています。'
        }
      ]
    }
  }),
  new FormatItem({
    id: 'rirekisho_job_change2',
    title: '転職用の履歴書（職歴欄短め）',
    description:
      '転職活動向けの履歴書テンプレートをスマホ・パソコンで無料作成できます。PDFダウンロード・コンビニ印刷にも対応しています。',
    // description: '一般的なA4サイズ2枚の履歴書テンプレートです。学歴・職歴の記入欄が少なめのレイアウトのため、まだ職歴がない場合や、社会人経験が短かい人におすすめです。',
    thumbnail: '/static/img/formats/rirekisho_job_change2.png',
    images: [
      '/static/img/formats/sample/rirekisho_short_01.jpg',
      '/static/img/formats/sample/rirekisho_short_02.jpg'
    ],
    newdetail1: 'A4サイズ/２枚',
    newdetail2: '職歴欄短め',
    newdetail3: '社会人経験少なめの方におすすめ',
    newdetail: '社会人経験少なめの方向け',
    pagenumbs: '2枚',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email',
      'contact',
      'contactTel',
      'contactEmail',
      'photo'
    ],
    hashs: ['履歴書', '転職'],
    components: {
      edit: RirekishoEdit,
      preview: RirekishoShortPreview
    },
    cards: RirekishoCards,
    sampleData: RirekishoSample,
    exampleSentences: jobChangeExampleSentences
  }),
  new FormatItem({
    id: 'rirekisho_job_change_old',
    title: '転職用の履歴書（旧JIS様式）',
    description:
      '履歴書の書き方・職歴の記入例・写真の貼り方までわかる見本付き履歴書テンプレートです。履歴書PDFのダウンロードやオンライン作成も可能。スマホ・PC対応、サンプル付きの履歴書フォーマットに沿って入力するだけで、突破率の高くなる履歴書が完成。初心者でも自分の強みを最大限に高める履歴書を作成できます。',
    // description: '豊富な例文やサンプル、フォーマットを用意しています。PCやスマホにも対応。',
    // description: '令和２年6月以前の旧様式です。日本工業規格（JIS）の規格に従ったA4サイズ2枚の一般的な履歴書テンプレートです。学歴・職歴の記入欄は比較的広めのつくりになっており、社会人経験が長い人にもおすすめです。',
    thumbnail: '/static/img/formats/rirekisho_job_change.png',
    images: [
      '/static/img/formats/sample/rirekisho_job_change_01.jpg',
      '/static/img/formats/sample/rirekisho_job_change_02.jpg'
    ],
    newdetail1: 'A4サイズ/２枚',
    newdetail2: '令和２年6月以前の旧様式',
    newdetail3: '社会人経験多めの方におすすめ',
    newdetail: '通勤時間や扶養者情報欄あり',
    pagenumbs: '2枚',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email',
      'contact',
      'contactTel',
      'contactEmail',
      'photo'
    ],
    hashs: ['履歴書', '転職'],
    components: {
      edit: RirekishoEdit,
      preview: RirekishoPreview
    },
    cards: RirekishoCards,
    sampleData: RirekishoSample,
    exampleSentences: jobChangeExampleSentences
  }),
  new FormatItem({
    id: 'rirekisho_job_new',
    title: '新卒用の履歴書',
    description:
      '新卒・就職活動向けの履歴書をスマホ・パソコンで無料作成できます。学歴や志望動機、自己PRを入力し、PDFで保存・印刷できます。',
    // description: '一般的なA4サイズ2枚の新卒用履歴書テンプレートです。職歴欄がなく、学歴欄や志望動機・特技・アピールポイント・インターンシップなどを広めにしたレイアウトになっています。',
    thumbnail: '/static/img/formats/rirekisho_job_new.png',
    images: [
      '/static/img/formats/sample/rirekisho_job_new_01.png',
      '/static/img/formats/sample/rirekisho_job_new_02.png'
    ],
    newdetail1: 'A4サイズ/２枚',
    newdetail2: '職歴欄なし',
    newdetail3: '学歴・志望動機・アピール欄が広め',
    newdetail: '職歴欄なしでアピール欄広め',
    pagenumbs: '2枚',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email',
      'contact',
      'contactTel',
      'contactEmail',
      'photo'
    ],
    hashs: ['履歴書', '新卒', '学生'],
    components: {
      edit: NewRirekishoEdit,
      preview: NewRirekishoPreview
    },
    cards: NewRirekishoCards,
    sampleData: RirekishoSample,
    exampleSentences: {
      // 志望動機
      reason: [
        {
          title: '業務内容に関心がある',
          description:
            '貴社が取り組まれているXX事業に関心があり、応募いたしました。特にXXな点に非常に魅力的を感じています。これまでの私の経験を最大限活用しつつ、ぜひ貴社の一員としてその成長に関わりたいと考えております。'
        },
        {
          title: '自身の経験を活かしたい',
          description:
            '自分のXXXという経験・スキルを活かして貴社に貢献できると考え、この度応募いたしました。今までの経験を活かしながら新しい業務にもチャレンジし、貴社の事業や組織の成長に貢献しながら自分も成長したいと考えております。'
        },
        {
          title: '企業のビジョンに共感した',
          description:
            '貴社のXXXXという企業ビジョンに共感するものがあり、今回応募いたしました。私自身もXXXXという点を大切にしたいと考えており、そのようなビジョンを大切にしている方々と一緒に働きたいと考えております。'
        },
        {
          title: 'インターンシップの経験を活かしたい',
          description:
            '実際に業務を体験してみて、作成した資料が分かりにくいと指摘を受けることがありました。どうすれば分かりやすい資料を作成できるか繰り返し試みました。自分にとって社会へ出た際の大きな課題であると気付く機会となり、自身が成長できる可能性を感じました。'
        },
        {
          title: '得意科目',
          description:
            '私の得意科目は数学です。難しい問題でも必ず正解があり、正解にたどり着いた時の達成感を感じることが好きです。また、難解な問題への取り組みを通して、根気強く物事を考えたり、書籍やインターネットで調べるなど多種の手段で解決する経験を積んできました。論理的な課題解決能力で貴社に貢献したいです。'
        },
        {
          title: 'ゼミ研究',
          description:
            '私が所属しているゼミでは、毎週課題テーマを設定し、研究結果を発表する機会があります。プレゼンテーションをするのは初めてだったので、当初は資料作成も発表もうまくできませんでした。経験を重ねることで、書籍や文献などから知識を得て資料にまとめたり、質問に対しての返答などができるようになっていきました。研究を通じて、物事を柔軟に考える重要性を学びました。'
        },
        {
          title: 'ボランティア活動',
          description:
            'XX震災後、私は復興支援活動としてXX地区の瓦礫撤去作業を行いました。チームリーダーを担当し、自分から率先して動いたり、周りに指示を出したりしながら活動しました。活動する中で、周りに指示を出すことの難しさや協力することの大切さを知りました。この経験で培ったリーダーシップや行動力を貴社で活かしたいと思っています。'
        },
        {
          title: '学生時代のアルバイト経験',
          description:
            '小売りのお店でアルバイトしていたことがあります。働いていたお店の売上が振るわない時期がありました。接客時に、同じ商品について複数回聞かれることがあり、責任者にディスプレイ方法の変更を提案したところ、来客数が増え、売上が前年比でアップすることがありました。この経験で得た客観的に判断する能力を活かしていきたいと考えています。'
        },
        {
          title: '自己PR',
          description:
            '私の長所は、コツコツと仕事を続けられる、継続力があるところです。大学で所属していたXXサークルの合宿は、部員全員の意見をまとめ、決定しています。私は100人以上いる部員の意見をまとめるために、アンケートを作成し、意見を聞き、集計していました。スケジュール管理も大変でしたが、全員の意見をまとめることがとても大変でした。この経験から、継続的な仕事を続けることができると考えております。'
        }
      ],
      // 資格
      license: licenseCommon,
      // 本人希望欄
      request: [
        {
          title: '連絡可能な時間帯',
          description:
            '連絡可能な時間帯：電話の場合、平日18時以降または土日祝日。現在在職中のため、平日日中のご連絡についてはメールでお送り頂ければ幸いです。'
        },
        {
          title: '帰社時間の希望',
          description:
            '子供の保育園の迎えのため、毎週水曜日は18時に退勤させていただければ幸いです。'
        },
        { title: '希望職種', description: '希望職種：XX職を希望します。' },
        { title: '勤務地の希望', description: '希望勤務地：XX店' },
        { title: '希望年収', description: '希望年収はXXX万円となります。' },
        { title: '特に希望がない場合', description: '貴社規定に従います。' }
      ]
    }
  }),
  new FormatItem({
    id: 'rirekisho_job_new_single',
    title: '新卒用A4一枚で書ける履歴書',
    description:
      '新卒・就職活動向けの履歴書をスマホ・パソコンで無料作成できます。学歴や志望動機、自己PRを入力し、PDFで保存・印刷できます。',
    // description: 'A4サイズ1枚におさまる新卒用履歴書テンプレートです。職歴欄がなく、コンパクトにまとめたレイアウトになっています。',
    thumbnail: '/static/img/formats/rirekisho_single_new.png',
    images: ['/static/img/formats/sample/rirekisho_single_new.png'],
    newdetail1: 'A4サイズ/1枚',
    newdetail2: '職歴欄なし',
    newdetail3: '比較的コンパクトなレイアウト',
    newdetail: '職歴欄なしでコンパクト',
    pagenumbs: '1枚',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email',
      'photo'
    ],
    hashs: ['履歴書', '新卒', '学生'],
    components: {
      edit: NewRirekishoEdit,
      preview: NewRirekishoSinglePreview
    },
    cards: NewRirekishoCards,
    sampleData: RirekishoSample,
    exampleSentences: {
      // 志望動機
      reason: [
        {
          title: '業務内容に関心がある',
          description:
            '貴社が取り組まれているXX事業に関心があり、応募いたしました。特にXXな点に非常に魅力的を感じています。これまでの私の経験を最大限活用しつつ、ぜひ貴社の一員としてその成長に関わりたいと考えております。'
        },
        {
          title: '自身の経験を活かしたい',
          description:
            '自分のXXXという経験・スキルを活かして貴社に貢献できると考え、この度応募いたしました。今までの経験を活かしながら新しい業務にもチャレンジし、貴社の事業や組織の成長に貢献しながら自分も成長したいと考えております。'
        },
        {
          title: '企業のビジョンに共感した',
          description:
            '貴社のXXXXという企業ビジョンに共感するものがあり、今回応募いたしました。私自身もXXXXという点を大切にしたいと考えており、そのようなビジョンを大切にしている方々と一緒に働きたいと考えております。'
        },
        {
          title: 'インターンシップの経験を活かしたい',
          description:
            '実際に業務を体験してみて、作成した資料が分かりにくいと指摘を受けることがありました。どうすれば分かりやすい資料を作成できるか繰り返し試みました。自分にとって社会へ出た際の大きな課題であると気付く機会となり、自身が成長できる可能性を感じました。'
        },
        {
          title: '得意科目',
          description:
            '私の得意科目は数学です。難しい問題でも必ず正解があり、正解にたどり着いた時の達成感を感じることが好きです。また、難解な問題への取り組みを通して、根気強く物事を考えたり、書籍やインターネットで調べるなど多種の手段で解決する経験を積んできました。論理的な課題解決能力で貴社に貢献したいです。'
        },
        {
          title: 'ゼミ研究',
          description:
            '私が所属しているゼミでは、毎週課題テーマを設定し、研究結果を発表する機会があります。プレゼンテーションをするのは初めてだったので、当初は資料作成も発表もうまくできませんでした。経験を重ねることで、書籍や文献などから知識を得て資料にまとめたり、質問に対しての返答などができるようになっていきました。研究を通じて、物事を柔軟に考える重要性を学びました。'
        },
        {
          title: 'ボランティア活動',
          description:
            'XX震災後、私は復興支援活動としてXX地区の瓦礫撤去作業を行いました。チームリーダーを担当し、自分から率先して動いたり、周りに指示を出したりしながら活動しました。活動する中で、周りに指示を出すことの難しさや協力することの大切さを知りました。この経験で培ったリーダーシップや行動力を貴社で活かしたいと思っています。'
        },
        {
          title: '学生時代のアルバイト経験',
          description:
            '小売りのお店でアルバイトしていたことがあります。働いていたお店の売上が振るわない時期がありました。接客時に、同じ商品について複数回聞かれることがあり、責任者にディスプレイ方法の変更を提案したところ、来客数が増え、売上が前年比でアップすることがありました。この経験で得た客観的に判断する能力を活かしていきたいと考えています。'
        },
        {
          title: '自己PR',
          description:
            '私の長所は、コツコツと仕事を続けられる、継続力があるところです。大学で所属していたXXサークルの合宿は、部員全員の意見をまとめ、決定しています。私は100人以上いる部員の意見をまとめるために、アンケートを作成し、意見を聞き、集計していました。スケジュール管理も大変でしたが、全員の意見をまとめることがとても大変でした。この経験から、継続的な仕事を続けることができると考えております。'
        }
      ],
      // 資格
      license: licenseCommon,
      // 本人希望欄
      request: [
        {
          title: '連絡可能な時間帯',
          description:
            '連絡可能な時間帯：電話の場合、平日18時以降または土日祝日。現在在職中のため、平日日中のご連絡についてはメールでお送り頂ければ幸いです。'
        },
        {
          title: '帰社時間の希望',
          description:
            '子供の保育園の迎えのため、毎週水曜日は18時に退勤させていただければ幸いです。'
        },
        { title: '希望職種', description: '希望職種：XX職を希望します。' },
        { title: '勤務地の希望', description: '希望勤務地：XX店' },
        { title: '希望年収', description: '希望年収はXXX万円となります。' },
        { title: '特に希望がない場合', description: '貴社規定に従います。' }
      ]
    }
  }),
  new FormatItem({
    id: 'internship',
    title: 'インターンシップ用の履歴書',
    description:
      '新卒・就職活動向けの履歴書をスマホ・パソコンで無料作成できます。学歴や志望動機、自己PRを入力し、PDFで保存・印刷できます。',
    // description: '一般的なA4サイズ2枚のインターンシップ用履歴書テンプレートです。職歴欄がなく、学歴欄や志望動機・特技・アピールポイント・インターンシップなどを広めにしたレイアウトになっています。',
    thumbnail: '/static/img/formats/rirekisho_job_new.png',
    images: [
      '/static/img/formats/sample/rirekisho_job_new_01.png',
      '/static/img/formats/sample/rirekisho_job_new_02.png'
    ],
    newdetail1: 'A4サイズ/２枚',
    newdetail2: '職歴欄なし',
    newdetail3: '学歴・志望動機・アピール欄が広め',
    newdetail: '職歴欄なしでアピール欄広め',
    pagenumbs: '2枚',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email',
      'contact',
      'contactTel',
      'contactEmail',
      'photo'
    ],
    hashs: ['履歴書', '新卒', '学生'],
    components: {
      edit: NewRirekishoEdit,
      preview: NewRirekishoPreview
    },
    cards: NewRirekishoCards,
    sampleData: RirekishoSample,
    exampleSentences: {
      // 志望動機
      reason: [
        {
          title: 'IT関連',
          description:
            '私は中学生時代からプログラミングに興味を持ち始めました。現在は、情報学科でコンピュータサイエンスを専攻し、より広域なIT技術を学んでいます。生活していく中で、プログラミングで世の中を変えていきたいという強い思いが芽生え始めました。中でも貴社は、IT業界の中においても、極めて先端的な取り組みされており、貴社のインターンを志望させていただきました。'
        },
        {
          title: 'リーダシップ',
          description:
            '私の長所は、何事も最後まで諦めない粘り強さです。高校ではバスケットボール部に所属していましたが、Aチームに選ばれず、なかなか公式戦に出ることができませんでした。しかし、そこで腐らず、自分にできることは何かを考え、前だけを見てやれることをやりました。その結果、3年生になってからレギュラーとして試合に出場することができるようになりました。この粘り強さを仕事にも活かすことで、貴社に貢献したいと考えています。'
        }
      ],
      // 資格
      license: licenseCommon,
      // 本人希望欄
      request: [
        {
          title: '連絡可能な時間帯',
          description:
            '連絡可能な時間帯：電話の場合、平日18時以降または土日祝日。現在在職中のため、平日日中のご連絡についてはメールでお送り頂ければ幸いです。'
        },
        {
          title: '帰社時間の希望',
          description:
            '子供の保育園の迎えのため、毎週水曜日は18時に退勤させていただければ幸いです。'
        },
        { title: '希望職種', description: '希望職種：XX職を希望します。' },
        { title: '勤務地の希望', description: '希望勤務地：XX店' },
        { title: '希望年収', description: '希望年収はXXX万円となります。' },
        { title: '特に希望がない場合', description: '貴社規定に従います。' }
      ]
    }
  }),
  new FormatItem({
    id: 'rerekisho_part_time',
    title: 'アルバイト用の履歴書',
    description:
      'アルバイト・パート応募向けの履歴書をスマホ・パソコンで無料作成できます。必要項目を入力し、PDFで保存・印刷できます。',
    // description: 'アルバイト用の履歴書テンプレート（A4サイズ2枚）です。勤務曜日・勤務期間の希望などを例文から選び、素早く応募書類を作成できます。',
    thumbnail: '/static/img/formats/rerekisho_part_time.png',
    images: [
      '/static/img/formats/sample/rirekisho_short_01.jpg',
      '/static/img/formats/sample/rirekisho_short_02.jpg'
    ],
    newdetail1: 'A4サイズ/２枚',
    newdetail2: '',
    newdetail3: '勤務曜日・勤務期間などの記載枠あり',
    newdetail: '勤務曜日・勤務期間記入可能',
    pagenumbs: '2枚',
    requiredBasicFields: ['all'],
    hashs: ['履歴書', 'バイト', 'パート'],
    components: {
      edit: RirekishoEdit,
      preview: RirekishoShortPreview
    },
    cards: RirekishoCards,
    sampleData: RirekishoSample,
    exampleSentences: {
      // 志望動機
      reason: [
        {
          title: '仕事内容に興味がある',
          description:
            'XXXをきっかけにXXXの仕事に興味を持ち、自分も働いてみたいと考えるようになりました。未経験ではありますが、新しいことを積極的に吸収し、意欲的に取り組みたいと考えています。'
        },
        {
          title: 'スキル・経験を活かす',
          description:
            '以前、同業種でX年間アルバイトをしていた経験があります。ひと通りの業務経験があるため、貴店での勤務時もお役に立てる場面があるかと思います'
        },
        {
          title: 'お店（会社）に好感を持った',
          description:
            '貴店を以前から利用しており、スタッフの方の対応やサービス内容に好感をもっておりました。また、学校から貴店までの距離も近いため、ぜひ長期間勤めたいと考えています。'
        },
        {
          title: '自分の経験を活かす',
          description:
            '大学ではXXについて学んでおり、より知識や経験を深めたいと考え今回応募いたしました。'
        },
        {
          title: '就活に活かしたい',
          description:
            'XX業界への就職を目指しており、関連するアルバイトをしたいと考えています。少しでも実際の業務に触れる機会を得ることで、経験を身に付けたいと考えています。'
        }
      ],
      // 資格
      license: licenseCommon,
      // 本人希望欄
      request: [
        { title: '希望職種', description: '希望職種：XXを希望します' },
        {
          title: '帰社時間の希望',
          description:
            '子供の保育園の迎えのため、毎週水曜日は18時に退勤させていただければ幸いです。'
        },
        {
          title: '勤務シフトの希望',
          description: '勤務可能日：月・火・水・土。週3～4日勤務希望です'
        },
        { title: '勤務地の希望', description: '希望勤務地：XX店' },
        {
          title: '希望年収',
          description: '現在の年収はOOO万円です。希望年収はXXX万円となります。'
        },
        { title: '特に希望がない場合', description: '貴社規定に従います。' }
      ]
    }
  }),
  new FormatItem({
    id: 'rirekisho_part_time2',
    title: 'パート（パートタイム）用の履歴書',
    description:
      'アルバイト・パート応募向けの履歴書をスマホ・パソコンで無料作成できます。必要項目を入力し、PDFで保存・印刷できます。',
    // description: 'パートタイム用の履歴書テンプレート（A4サイズ2枚）です。勤務曜日・勤務期間の希望などを例文から選び、素早く応募書類を作成できます。',
    thumbnail: '/static/img/formats/rirekisho_part_time2.png',
    images: [
      '/static/img/formats/sample/rirekisho_short_01.jpg',
      '/static/img/formats/sample/rirekisho_short_02.jpg'
    ],
    newdetail1: 'A4サイズ/２枚',
    newdetail2: '',
    newdetail3: '勤務曜日・勤務期間などの記載枠あり',
    newdetail: '勤務曜日・勤務期間記入可能',
    pagenumbs: '2枚',
    requiredBasicFields: ['all'],
    hashs: ['履歴書', 'バイト', 'パート'],
    components: {
      edit: RirekishoEdit,
      preview: RirekishoShortPreview
    },
    cards: RirekishoCards,
    sampleData: RirekishoSample,
    exampleSentences: {
      // 志望動機
      reason: [
        {
          title: '仕事内容に興味がある',
          description:
            'XXXをきっかけにXXXの仕事に興味を持ち、自分も働いてみたいと考えるようになりました。実務は未経験ですが、新しいことを積極的に吸収し、意欲的に取り組みたいと考えています。'
        },
        {
          title: 'スキル・経験を活かす',
          description:
            '以前、同業種でX年間の勤務経験があります。ひと通りの業務経験があるため、貴店での勤務時もお役に立てる場面があるかと思います'
        },
        {
          title: 'お店（会社）に好感を持った',
          description:
            '貴店を以前から利用しており、スタッフの方の対応やサービス内容に好感をもっておりました。また、自宅から貴店までの距離も近いため、できるだけ長く勤めたいと考えています。'
        }
      ],
      // 資格
      license: licenseCommon,
      // 本人希望欄
      request: [
        { title: '希望職種', description: '希望職種：XXを希望します' },
        {
          title: '帰社時間の希望',
          description:
            '子供の保育園の迎えのため、毎週水曜日は18時に退勤させていただければ幸いです。'
        },
        {
          title: '勤務シフトの希望',
          description: '勤務可能日：月・火・水・土。週3～4日勤務希望です'
        },
        { title: '勤務地の希望', description: '希望勤務地：XX店' },
        {
          title: '希望年収',
          description: '現在の年収はOOO万円です。希望年収はXXX万円となります。'
        },
        { title: '特に希望がない場合', description: '貴社規定に従います。' }
      ]
    }
  }),
  new FormatItem({
    id: 'rirekisho_single',
    title: 'A4一枚で書ける履歴書',
    description:
      '転職活動向けの履歴書テンプレートをスマホ・パソコンで無料作成できます。PDFダウンロード・コンビニ印刷にも対応しています。',
    // description: 'A4サイズ1枚におさまる履歴書テンプレートです。アルバイト・パートタイムや、インターンシップなど、簡略化した履歴書でも問題ない場合におすすめです。',
    thumbnail: '/static/img/formats/rirekisho_single.png',
    images: ['/static/img/formats/sample/rirekisho_single.jpg'],
    newdetail1: 'A4サイズ/1枚',
    newdetail2: '',
    newdetail3: '比較的コンパクトなレイアウト',
    newdetail: 'コンパクトなレイアウト',
    pagenumbs: '1枚',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email',
      'photo'
    ],
    hashs: ['履歴書', '転職'],
    components: {
      edit: RirekishoEdit,
      preview: RirekishoSinglePreview
    },
    cards: RirekishoCards,
    sampleData: RirekishoSingleSample,
    exampleSentences: {
      // 志望動機
      reason: [
        {
          title: '仕事内容に興味がある',
          description:
            'XXXをきっかけにXXXの仕事に興味を持ち、自分も働いてみたいと考えるようになりました。実務は未経験ですが、新しいことを積極的に吸収し、意欲的に取り組みたいと考えています。'
        },
        {
          title: 'スキル・経験を活かす',
          description:
            '以前、同業種でX年間の就業経験があります。ひと通りの業務内容を経験しておりますが、特にXXXが得意です。今後も幅広い視野で業務を進めたいと考えています。'
        },
        {
          title: '自分の経験を活かす',
          description:
            '大学ではXXについて学んでおり、より知識や経験を深めたいと考え今回応募いたしました。'
        },
        {
          title: '就活に活かしたい',
          description:
            'XX業界への就職を目指しており、関連するアルバイトをしたいと考えています。少しでも実際の業務に触れる機会を得ることで、経験を身に付けたいと考えています。'
        },
        {
          title: 'お店（会社）に好感を持った',
          description:
            '貴店（貴社のサービス・商品）を以前から利用しており、スタッフの方の対応やサービス内容に好感をもっておりました。また、自宅から貴店（貴社）までの距離も近いため、できるだけ長く勤めたいと考えています。'
        }
      ],
      // 資格
      license: licenseCommon,
      // 本人希望欄
      request: [
        { title: '希望職種', description: '希望職種：XXを希望します' },
        {
          title: '帰社時間の希望',
          description:
            '子供の保育園の迎えのため、毎週水曜日は18時に退勤させていただければ幸いです。'
        },
        {
          title: '勤務シフトの希望',
          description: '勤務可能日：月・火・水・土。週3～4日勤務希望です'
        },
        { title: '勤務地の希望', description: '希望勤務地：XX店' },
        {
          title: '希望年収',
          description: '現在の年収はOOO万円です。希望年収はXXX万円となります。'
        },
        { title: '特に希望がない場合', description: '貴社規定に従います。' }
      ]
    }
  }),
  new FormatItem({
    id: 'rirekisho_arbeit_debut',
    title: 'アルバイトデビュー履歴書',
    description: '初めてのアルバイトで迷わずに作成できるテンプレートです',
    thumbnail: '/static/img/formats/rirekisho_single.png',
    images: ['/static/img/formats/sample/rirekisho_single.jpg'],
    newdetail1: 'A4サイズ/1枚',
    newdetail2: '',
    newdetail3: 'チャット形式で簡単作成',
    newdetail: 'アルバイト初心者向け',
    pagenumbs: '1枚',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email',
      'photo'
    ],
    hashs: ['履歴書', 'アルバイト'],
    components: {
      edit: RirekishoEdit,
      preview: RirekishoSinglePreview
    },
    cards: RirekishoArbeitDebutCards,
    sampleData: RirekishoSingleSample,
    exampleSentences: {
      reason: [
        {
          title: '仕事内容に興味がある',
          description:
            'XXXをきっかけにXXXの仕事に興味を持ち、自分も働いてみたいと考えるようになりました。実務は未経験ですが、新しいことを積極的に吸収し、意欲的に取り組みたいと考えています。'
        },
        {
          title: 'お店（会社）に好感を持った',
          description:
            '貴店（貴社のサービス・商品）を以前から利用しており、スタッフの方の対応やサービス内容に好感をもっておりました。また、自宅から貴店（貴社）までの距離も近いため、できるだけ長く勤めたいと考えています。'
        },
        {
          title: '就活に活かしたい',
          description:
            'XX業界への就職を目指しており、関連するアルバイトをしたいと考えています。少しでも実際の業務に触れる機会を得ることで、経験を身に付けたいと考えています。'
        },
        {
          title: '自分の経験を活かす',
          description:
            '大学ではXXについて学んでおり、より知識や経験を深めたいと考え今回応募いたしました。'
        },
        {
          title: 'スキル・経験を活かす',
          description:
            '以前、同業種でX年間の就業経験があります。ひと通りの業務内容を経験しておりますが、特にXXXが得意です。今後も幅広い視野で業務を進めたいと考えています。'
        }
      ],
      license: [
        { title: '原付免許', description: '原動機付自転車免許取得' },
        { title: '自動車免許', description: '普通自動車第一種運転免許取得' },
        {
          title: '自動車免許(AT限)',
          description: '普通自動車第一種運転免許(AT限定)取得'
        },
        { title: '英検', description: '実用英語技能検定X級合格' },
        { title: 'TOEIC', description: 'TOEIC公開テストXXX点取得' }
      ],
      request: [
        { title: '希望職種', description: '希望職種：XXを希望します' },
        {
          title: '勤務シフトの希望',
          description: '勤務可能日：月・火・水・土。週3～4日勤務希望です'
        },
        { title: '勤務地の希望', description: '希望勤務地：XX店' },
        { title: '特に希望がない場合', description: '貴社規定に従います。' }
      ]
    }
  }),
  new FormatItem({
    id: 'rirekisho_nophoto_double',
    title: '証明写真なしの履歴書（職歴欄長め）',
    description:
      '転職活動向けの履歴書テンプレートをスマホ・パソコンで無料作成できます。PDFダウンロード・コンビニ印刷にも対応しています。',
    // description: 'A4サイズ2枚・証明写真なしで、学歴・職歴欄が長めの履歴書テンプレートです。WEBエントリーなど、証明写真不要とされている場合におすすめです。',
    thumbnail: '/static/img/formats/rirekisho_nophoto_double.jpg',
    images: [
      '/static/img/formats/rirekisho_nophoto_double.jpg',
      '/static/img/formats/rirekisho_nophoto_double2.jpg'
    ],
    newdetail1: 'A4サイズ/２枚',
    newdetail2: '証明写真なし',
    newdetail3: '学歴・職歴が長め',
    newdetail: '写真なし、経歴欄が長め',
    pagenumbs: '2枚',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email',
      'contact',
      'contactTel',
      'contactEmail'
    ],
    hashs: ['履歴書', '転職'],
    components: {
      edit: RirekishoEdit,
      preview: RirekishoDoubleNophotoPreview
    },
    cards: RirekishoNophotoCards,
    sampleData: RirekishoSample,
    exampleSentences: jobChangeExampleSentences
  }),
  new FormatItem({
    id: 'rirekisho_nophoto',
    title: '証明写真なしの履歴書（職歴欄短め）',
    description:
      '転職活動向けの履歴書テンプレートをスマホ・パソコンで無料作成できます。PDFダウンロード・コンビニ印刷にも対応しています。',
    // description: 'A4サイズ1枚・証明写真なしで、学歴・職歴欄が短いコンパクトな履歴書テンプレートです。WEBエントリーなど、証明写真不要とされている場合におすすめです。',
    thumbnail: '/static/img/formats/rirekisho_nophoto.png',
    images: ['/static/img/formats/sample/rirekisho_nophoto.jpg'],
    newdetail1: 'A4サイズ/1枚',
    newdetail2: '証明写真なし',
    newdetail3: '学歴・職歴が短め',
    newdetail: '写真なし、経歴欄が長め',
    pagenumbs: '1枚',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email'
    ],
    hashs: ['履歴書', '転職'],
    components: {
      edit: RirekishoEdit,
      preview: RirekishoSingleNophotoPreview
    },
    cards: RirekishoNophotoCards,
    sampleData: RirekishoSample,
    exampleSentences: {
      // 志望動機
      reason: [
        {
          title: '仕事内容に興味がある',
          description:
            'XXXをきっかけにXXXの仕事に興味を持ち、自分も働いてみたいと考えるようになりました。実務は未経験ですが、新しいことを積極的に吸収し、意欲的に取り組みたいと考えています。'
        },
        {
          title: 'スキル・経験を活かす',
          description:
            '以前、同業種でX年間の就業経験があります。ひと通りの業務内容を経験しておりますが、特にXXXが得意です。今後も幅広い視野で業務を進めたいと考えています。'
        },
        {
          title: '自分の経験を活かす',
          description:
            '大学ではXXについて学んでおり、より知識や経験を深めたいと考え今回応募いたしました。'
        },
        {
          title: '就活に活かしたい',
          description:
            'XX業界への就職を目指しており、関連するアルバイトをしたいと考えています。少しでも実際の業務に触れる機会を得ることで、経験を身に付けたいと考えています。'
        },
        {
          title: 'お店（会社）に好感を持った',
          description:
            '貴店（貴社のサービス・商品）を以前から利用しており、スタッフの方の対応やサービス内容に好感をもっておりました。また、自宅から貴店（貴社）までの距離も近いため、できるだけ長く勤めたいと考えています。'
        }
      ],
      // 資格
      license: licenseCommon,
      // 本人希望欄
      request: [
        { title: '希望職種', description: '希望職種：XXを希望します' },
        {
          title: '帰社時間の希望',
          description:
            '子供の保育園の迎えのため、毎週水曜日は18時に退勤させていただければ幸いです。'
        },
        {
          title: '勤務シフトの希望',
          description: '勤務可能日：月・火・水・土。週3～4日勤務希望です'
        },
        { title: '勤務地の希望', description: '希望勤務地：XX店' },
        {
          title: '希望年収',
          description: '現在の年収はOOO万円です。希望年収はXXX万円となります。'
        },
        { title: '特に希望がない場合', description: '貴社規定に従います。' }
      ]
    }
  }),
  new FormatItem({
    id: 'english_resume',
    title: '英語の履歴書',
    description:
      '外資系企業や海外企業への応募に必須となる、標準的な英文レジュメのテンプレートです。日本の履歴書とは異なり、これまでの経歴やスキル、具体的な実績を簡潔にまとめて「自分がいかに即戦力であるか」を戦略的にアピールするための書類になります。',
    thumbnail: '/static/img/formats/english_resume.png',
    images: ['/static/img/formats/sample/english_resume.png'],
    newdetail1: 'A4サイズ/1枚',
    newdetail2: '',
    newdetail3: '外資系・海外企業向け',
    newdetail: '英文レジュメ',
    pagenumbs: '1枚',
    requiredBasicFields: ['name', 'birth', 'tel', 'email'],
    hashs: ['英語', '履歴書', 'レジュメ', 'resume', '外資'],
    components: {
      edit: EnglishResumeEdit,
      preview: EnglishResumePreview
    },
    cards: EnglishResumeCards,
    sampleData: EnglishResumeSample,
    exampleSentences: {}
  })
  // new FormatItem({
  //   id: 'rirekisho_wareki',
  //   title: '【和暦】転職用の履歴書（JIS規格）',
  //   description: '（ベータ版）和暦表記の日本工業規格（JIS）の規格に従ったA4サイズの一般的な履歴書テンプレートです。学歴・職歴の記入欄は比較的広めのつくりになっており、社会人経験が長い人にもおすすめです。',
  //   thumbnail: '/static/img/formats/rirekisho_job_change.png',
  //   images: [
  //     '/static/img/formats/sample/rirekisho_job_change_01.jpg',
  //     '/static/img/formats/sample/rirekisho_job_change_02.jpg'
  //   ],
  //   requiredBasicFields: ['name', 'furigana', 'birth', 'sex', 'address', 'addressFurigana', 'tel', 'email', 'contact', 'contactTel', 'contactEmail', 'photo'],
  //   hashs: ['履歴書'],
  //   components: {
  //     edit: RirekishoEdit,
  //     preview: RirekishoPreviewWareki
  //   },
  //   cards: RirekishoCards,
  //   sampleData: RirekishoSample,
  //   exampleSentences: jobChangeExampleSentences
  // })
]

// if (process.env.VUE_APP_MODE !== 'production') {
//   formatsIndex.push(new FormatItem({
//     id: 'shokumukeirekisho',
//     title: '職務経歴書',
//     description: '（ベータ版）A4サイズの職務経歴書テンプレートです。自分のスキル・経験や、会社ごとに実績など一般的な項目が入力できます。転職活動などでお使いください。',
//     // thumbnail: '/static/img/formats/rirekisho_job_change.png',
//     thumbnail: '/static/img/formats/shokurekisho-min.png',
//     images: [
//       // '/static/img/formats/sample/rirekisho_job_change_01.jpg',
//       // '/static/img/formats/sample/rirekisho_job_change_02.jpg'
//       '/static/img/formats/sample/shokurekisho.png'
//     ],
//     requiredBasicFields: ['name'],
//     hashs: ['職務経歴書'],
//     components: {
//       edit: ShokurekishoEdit,
//       preview: ShokurekishoPreview
//     },
//     // cards: RirekishoCards,
//     cards: ShokurekiCards,
//     sampleData: ShokurekishoSample,
//     // exampleSentences: jobChangeExampleSentences
//     exampleSentences: {
//       summary: [
//         {type: 'others', name: 'はじめての転職', sentences: '大学卒業後、株式会社XXに入社。XX事業部・XX職として配属されました。主にXXを担当し、XXに関する業務やXXに携わってきました。'},
//         {type: 'others', name: '2社の転職を経験', sentences: '大学を卒業後、新卒でXX会社に入社しXX職としてXX業界のXXに携わりました。2社目のXX社ではXX職としてXXやXXを担当、XXの経験を積みました。'},
//         {type: 'others', name: '複数社の転職を経験', sentences: '大学を卒業後、XX会社のXX職をX年勤めたのち、XX会社のXX職やXX会社のXX職を経験。20XX年より株式会社XXに入社し、XX職として勤務。主にXXに従事し、XXやXXの業務を担当しています。'}
//         // {type: 'others', name: 'エンジニア', sentences: '大学を卒業後、ソフトウェア開発会社に入社。一貫して金融業界の業務システム開発に携わる。1社目ではシステムエンジニアとしてプログラム基本設計から開発、テストをｘ年担当後、プロジェクトリーダーとしてプロジェクトの進捗管理を担当。2社目のシステムインテグレーターでは、加えて顧客折衝の経験を積む。'},
//         // {type: 'others', name: '営業', sentences: '大学を卒業後、求人情報サイトを運営する株式会社◯◯に入社。営業職として、新規顧客の開拓を中心に取り組んでおりました。直近3年間は毎年目標売上を達成、昨年は120％達成により社内賞も受賞しました。チームリーダーを任されており、3名のチームメンバーの業績管理の経験もあります。'},
//         // {type: 'others', name: '事務', sentences: '株式会社〇〇において、営業事務として5年間従事。営業担当8名の営業資料や契約書類の作成に加え、電話対応・来客対応・精算業務などに携わってきました。商品の知識を深めて営業担当とコミュニケーションをとることで、バックオフィスとの連携が円滑に回るようになり売上向上につながったと評価をいただきました。また、業務フローの整備や書類作成の簡略化など日々の業務の効率化にも取り組み、会社に貢献してきました。'},
//         // {type: 'others', name: 'その他', sentences: '大学卒業後、株式会社〇〇に入社。XXといった業務に携わってきました。社外との折衝業務が多く、社内・外を問わず円滑なコミュニケーションを心掛けてきました。在職中はxxxxの資格を取得し、現在xxxxのスペシャリストを目指して勉強しております。今後は前職の経験を活かし、短期間で貴社の戦力となれるよう努力いたします。'}
//       ],
//       prMessage: [
//         {type: 'others', name: 'スキルをアピール', sentences: '現職にてXXを目的としたXXに関わり、実務経験を積んできました。新しい技術や情報についても積極的に勉強し、チームのメンバーも交えて情報共有しながら実務で活かすように取り組んでいます。'
//         },
//         {type: 'others', name: '同業種・業界での経験をアピール', sentences: '現職では、XXメーカーのXX業務に長年携わっていました。ターゲットであるXXに適したXXなどの施策を実施し、前年対比XXX％の売上を達成しました。今までに学んできたXXの経験を、今回応募した貴社のXXでも活かしたいと考えています。'
//         },
//         {type: 'others', name: 'マネジメント経験をアピール', sentences: '現職にてマネージャーをX年間経験しまし、社員が互いに刺激を与え合いながら成長していく組織作りに注力してきました。結果、社員同士の意識が目標に対して統一され、速やかな数値達成ができました。柔軟な対応力とXXの経験を、今回応募した貴社のXXでも活かしたいと考えています。'
//         },
//         {type: 'others', name: '事務能力の高さ・効率性をアピール', sentences: 'ケアレスミスをなくし、常に効率改善の余地がないか考えながら業務に取り組むように心がけています。現職では業務フローの見直しや日々の書類業務の自動化を主導しまし、全体の作業時間をXX％短縮させることに成功しました。特にXX関連業務の書類・ドキュメント作成の経験が豊富なことが強みです。'
//         }
//         // {type: 'others', name: 'エンジニア', sentences: '開発経験が豊富です。現職にて自社運営サイトのアクセス増加を目的とした新規機能開発に携わりました。サーバーサイドを担当し高速化・効率化を実現してきました。実務でのプログラミング経験から得た知識に加え、最近はプライベートでandroidアプリケーションの開発も行いました。新しい技術に関しても積極的に取り組んでいきます。チームマネジメント経験があります。少人数ながらチームリーダーを担当しました。メンバー間のコミュニケーションを重要視して円滑な進捗はもちろん、職務を通して全員がスキルアップしながら開発が行えるようマネジメントを心掛けました。'
//         // },
//         // {type: 'others', name: '営業', sentences: '前職では、エリアマネージャーを計5年経験しました。売上目標達成のため、店舗ごとに定期的に分析を行いKPIを設定。メンバーにはKPIとして設定したプロセスを完遂することを要望しました。その結果、目標を全て達成。売上目標も当初から20%増と推移し、非常に高い成果を残すことができました。扱う商材は変わりますが、お客様や店舗の状況を調査し戦略を立てた経験や、多数のメンバーのマネジメント経験は、貴社でも活かせるものと思います。'},
//         // {type: 'others', name: '事務', sentences: '期限を守った上でミスなく確実にドキュメント作成を行ってきました。ダブルチェックを徹底し責任をもって仕事を仕上げます。また、常に効率改善の余地がないか考えながら日々の業務に取り組みます。前職では業務フローの見直しや日々の書類業務の自動化を主導し、全体の作業時間を大幅に短縮させることに成功しました。事務能力を活かして貴社に貢献したいと考えております。'},
//         // {type: 'others', name: 'その他', sentences: '前職にてマネージャーを3年間経験しました。社員が互いに刺激を与え合いながら成長していく組織作りに注力してきました。結果として社員同士の意識が目標に対して統一され、速やかな数値達成ができました。柔軟な対応力と〇〇の経験を活かして、必ず貴社でお役に立てるものと考えております。何事も素直に吸収していけるよう、努力する気持ちを忘れずに頑張ります。'}
//       ]
//     }
//   }))
// }
export default formatsIndex
